import React from 'react';
import { Button, FormCheck as Checkbox, Row, Col } from 'react-bootstrap';

//import filterFactory from 'react-bootstrap-table2-filter';

import Table from '../Table';
import { IForecastHistory, IForecastOverview } from '../../lib/types/types';

import { Forecast } from '../../lib/dataAccess/DataAccess';
import Loading from '../visuals/Loading';
import ErrorMessage from '../visuals/ErrorMessage';
import { Prognosis, dateToString } from '../../lib/utilities';

import { ColumnDescription } from 'react-bootstrap-table-next';

interface ExtendedIForecastHistory extends IForecastHistory {
    userName: string
}

interface Props {
    forecastId: number,
    forecast?: IForecastOverview,
    setPrognosis: {(prognosis: number) : void}
}
interface State { 
    error: string | null,
    isLoading: boolean,
    forecastHistory: ExtendedIForecastHistory[]
}

export default class ForecastHistory extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.fetchData = this.fetchData.bind(this);
        
        this.state = {
            error: null,
            isLoading: true,
            forecastHistory: []
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    async fetchData() {
        try {
            const forecastHistory = await Forecast.getForecastHistory(this.props.forecastId);

            const extendedHistory = forecastHistory
                                    .filter(h => h.prognosis !== null)
                                    .map(history => ({ ...history, userName: history.user.userName }))
                                    .reverse();

            this.setState({forecastHistory: extendedHistory, isLoading: false});
        }
        catch(error) {
            this.setState({error, isLoading: false})
        }
    }

    render() {
        const { error, isLoading, forecastHistory } = this.state

        const columns : ColumnDescription<any, ExtendedIForecastHistory>[] = [{
                dataField: 'id',
                text: 'ID',
                hidden: true
            }, {
                dataField: 'sysStartTime',
                text: 'Datum',
                headerStyle: {width:'7rem'},
                formatter: (cell, row: ExtendedIForecastHistory) => (<div>
                    {dateToString(cell)}
                </div>)
            }, {
                dataField: 'userName',
                text: 'Redigerad av'
            }, {
                dataField: 'prognosis',
                text: 'Prognos',
                formatter: (cell: number, row: ExtendedIForecastHistory) => (<div>
                    {cell ? Prognosis.enum[cell][/*this.props.forecast ? this.props?.forecast?.studentProgram?.startsWith('GR') ? 'msName' : 'hsName' : */'name'] : '--'}
                </div>)
            }, {
                dataField: 'restore',
                text: '',
                isDummyField: true,
                hidden: this.props.forecast ? !this.props.forecast.writable : false,
                headerStyle: {width:'7rem', textAlign: 'center'},
                formatter: (_, row: ExtendedIForecastHistory, i: number) => (<div style={{textAlign:'center'}}>
                    <Button disabled={i === 0} title={i === 0 ? 'Aktuellt värde' : ''} onClick={() => this.props.setPrognosis(row.prognosis)}>{'Återställ'}</Button>
                </div>)
            }
        ];

        return (<div className={"render-component-administration-editRolePermission"} style={{position:'relative'}}>
            <ErrorMessage style={{marginBottom:'1rem'}} hidden={error === null}>{error}</ErrorMessage>
            <Table keyField={'id'} columns={columns} data={forecastHistory} loading={isLoading} searchHidden={true} pageSize={10} />
        </div>);
    }
}